// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-ColorCard-ColorCard-module__preview--P1Xmr {
  border: 1px solid #d9d9d9;
}
.ant-color-picker-format-select .ant-select-item:nth-child(2) {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/ColorCard/ColorCard.module.less"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;AAGA;EACE,aAAA;AADF","sourcesContent":[".preview {\n  border: 1px solid #d9d9d9;\n}\n\n// костыль для скрытия HSB, так как формат не нужно поддерживать\n:global(.ant-color-picker-format-select .ant-select-item:nth-child(2)) {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"preview": `src-components-ColorCard-ColorCard-module__preview--P1Xmr`
};
export default ___CSS_LOADER_EXPORT___;
